import { raundUrl } from '@/lib/custom'
import { useCampaignHeaders } from '@/lib/useCampaignHeaders'
import { useCampaignSlug } from '@/lib/useCampaignSlug'
import { useLocalStorageClear } from '@/lib/useLocalStorageClear'

export const useTokenRefresh = () => {
  const { LOCAL_STORAGE_USERNAME_KEY, LOCAL_STORAGE_REFRESH_KEY, LOCAL_STORAGE_JWT_KEY, gen } = useCampaignSlug()
  const clear = useLocalStorageClear()
  const { headers } = useCampaignHeaders()

  const refreshToken = async () => {
    try {
      const response = await fetch(raundUrl.refresh, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          refresh_token: localStorage.getItem(LOCAL_STORAGE_REFRESH_KEY),
          username: localStorage.getItem(LOCAL_STORAGE_USERNAME_KEY),
        }),
      })

      if (!response.ok) {
        const responseStatus = response.status
        // キャンペーン期間外の場合
        if (responseStatus === 400) {
          location.href = gen('/')
        }
      }
      const res = await response.json()
      const result = res.result

      if (result.status === 200) {
        localStorage.setItem(LOCAL_STORAGE_JWT_KEY, result.id_token)
        location.reload()
      }

      if (result.status === 400 || result.status === 401 || result.status === 403) {
        clear()
        location.href = gen('/auth/signin')
      }

      if (result.status === 500) {
        clear()
        location.href = gen('/auth/signin')
      }
    } catch (error) {
      location.href = gen('/auth/signin')
    }
  }
  return { refreshToken }
}
